<div class="section">
    <div class="px-3">
        <div class="theme-container">
            <h1 class="section-title">Our Restrooms Service</h1>
            <p class="section-desc text-muted">This is what we do and we do it perfectly.</p>

            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3">
                    <h1 class="secondary-font primary-color text-center">Restroom Status</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse semper lobortis quam, id imperdiet mi feugiat quis. Cras a odio posuere, rhoncus quam vitae, commodo neque. Nunc mollis velit vulputate, volutpat diam vitae, egestas turpis. In posuere tempor lorem, sit amet pulvinar nunc accumsan a. Quisque sem tellus, congue at eleifend sit amet, consectetur sit amet est. Integer sodales quam quis elit commodo consequat. Aenean posuere augue a justo gravida elementum laoreet tincidunt enim. Nullam sagittis mauris id dui scelerisque, eget dignissim est hendrerit. Praesent fringilla commodo egestas. Suspendisse bibendum purus vitae mi mattis laoreet.</p>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3">
                    <img src="assets/images/restroom1.png" alt="about-2" class="mw-100">
                </div>
            </div>


            <!-- <div fxLayout="row wrap" class="services-wrapper">
                <div fxFlex="100" fxFlex.gt-md="100" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Engaged/Vacant View</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:auto; width: auto" [src]="'assets/images/restroom1.png'" />
                        </div>
                    </mat-card>
                </div>
            </div> -->


            <!-- <div fxLayout="row wrap" class="services-wrapper">
                <div fxFlex="100" fxFlex.gt-md="50" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Balcony vacant</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:auto; width: auto" [src]="'assets/images/restroom2.png'" />
                        </div>
                    </mat-card>
                </div>
                <div fxFlex="100" fxFlex.gt-md="50" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Balcony engaged</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <img style="height:auto; width: auto" [src]="'assets/images/restroom3.png'" />
                        </div>
                    </mat-card>
                </div>
            </div> -->

            <a mat-raised-button routerLink="/restrooms" color="primary" class="uppercase">Read more about our restrooms service</a>
        </div>
    </div>
</div>